import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'

export const createRoadmapBaseEventsCreateCriteriaModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "RoadmapBaseEventCriteriaCreateModal" */
    './RoadmapBaseEventCriteriaCreateModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
